<template>
    <main v-if="!isLoading">
        <div class="py-4 container-fluid">
            <div class="card shadow-lg">
                <div class="card-body p-3">
                    <div class="row gx-4">
                        <div class="col-auto">
                            <div class="avatar avatar-xl position-relative">
                                <img src="/user.png" alt="profile_image"
                                    class="shadow-sm w-100 border-radius-lg" />
                            </div>
                        </div>
                        <div class="col-auto my-auto">
                            <div class="h-100">
                                <h5 class="mb-1">
                                    {{ userIDLocal !== undefined ? `${user.name} ${user.last_name}` : 'Usuario nuevo' }}
                                </h5>
                                <p class="mb-0 font-weight-bold text-sm">{{ userIDLocal !== undefined ? user.rol : 'META' }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-1 container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <argon-alert v-if="showAlert" color="danger">
                            <strong>Alerta!</strong> Existen campos vacios que son
                            obligatorios!
                        </argon-alert>
                        <argon-alert v-if="showSuccess" color="success" :dismissible="true">
                            <strong>Completado!</strong> Campos guardados correctamente!
                        </argon-alert>
                        <div class="card-body">
                            <p class="text-uppercase text-sm">Información del usuario</p>
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label">Nombre</label>
                                    <argon-input v-model="user.name" @valid="absoluteValidation($event)" :isRequired="true"
                                        id="0" name="Nombre" />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label">Apellidos</label>
                                    <argon-input v-model="user.last_name" @valid="absoluteValidation($event)"
                                        :isRequired="true" id="1" name="Apellidos" />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label">Email</label>
                                    <argon-input v-model="user.email" @valid="absoluteValidation($event)" :isRequired="true"
                                        id="2" name="Email" />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label">Teléfono</label>
                                    <argon-input v-model="user.phone" @valid="absoluteValidation($event)" :isRequired="true"
                                        id="3" name="Telèfono" />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label">Rol</label>
                                    <!-- <argon-input v-model="user.rol" @valid="absoluteValidation($event)" :isRequired="true"
                                        id="4" name="Rol" /> -->

                                    <select class="form-select" aria-label="Default select example"
                                        @change="changeRol($event.target.value)">
                                        <option value="Administrador"
                                            :selected="user.rol === 'Administrador' ? true : false">
                                            Administrador
                                        </option>
                                        <option value="Panel Web" :selected="user.rol === 'Panel Web' ? true : false">
                                            Panel Web
                                        </option>
                                        <option value="Panel Auxilio Vial"
                                            :selected="user.rol === 'Panel Auxilio Vial' ? true : false">
                                            Panel Auxilio Vial
                                        </option>
                                        <option value="Usuario" :selected="user.rol === 'Usuario' ? true : false">
                                            Usuario
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-6" v-if="userIDLocal === undefined">
                                    <label for="example-text-input" class="form-control-label">Contraseña</label>
                                    <argon-input v-model="user.password" @valid="absoluteValidation($event)"
                                        :isRequired="true" id="5" name="Contraseña" />
                                </div>
                                <div class="row mt-4">
                                    <div class="col-md-12">
                                        <argon-button color="primary" size="lg" class="ms-auto"
                                            @click-callback="finalValidation" :fullWidth="true">Guardar</argon-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
  
<script>
// import setNavPills from "@/assets/js/nav-pills.js";
// import setTooltip from "@/assets/js/tooltip.js";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import { mapActions, mapGetters } from "vuex";
const body = document.getElementsByTagName("body")[0];

export default {
    name: "user-card",
    components: { ArgonInput, ArgonButton, ArgonAlert },
    props: {
        userID: { type: String, required: true },
    },
    computed: {
        ...mapGetters('auth', ["getAuthToken"]),
    },
    data() {
        return {
            isLoading: true,
            showAlert: false,
            showSuccess: false,
            valid: Array(6).fill(true),
            userIDLocal: this.userID,
            user: {
                name: "",
                last_name: "",
                rol: "Administrador",
                email: "",
                phone: "",
                password: ""
            },
        };
    },
    mounted() {
        this.$store.state.isAbsolute = true;
    },
    beforeMount() {
        this.$store.state.imageLayout = "profile-overview";
        this.$store.state.showNavbar = true;
        this.$store.state.showFooter = true;
        this.$store.state.hideConfigButton = true;
        body.classList.add("profile-overview");
    },
    beforeUnmount() {
        this.$store.state.isAbsolute = false;
        this.$store.state.imageLayout = "default";
        this.$store.state.showNavbar = true;
        this.$store.state.showFooter = true;
        this.$store.state.hideConfigButton = false;
        body.classList.remove("profile-overview");
    },
    created() {
        if (this.userIDLocal !== '0') {
            this.plain
                .get(`/users/${this.userIDLocal}`, {
                    headers: {
                        'Authorization': this.getAuthToken
                    }
                })
                .then((response) => {
                    delete response.data.id;
                    delete response.data.created_at;
                    delete response.data.updated_at;
                    delete response.data.password;
                    this.user = response.data;
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.isLoading = false;
                    console.log(err);
                });
        } else {
            this.userIDLocal = undefined;
            this.valid = Array(5).fill(true)
            this.isLoading = false;
        }
    },
    methods: {
        ...mapActions('auth', ["registerUser"]),
        absoluteValidation(event) {
            this.showAlert = false;
            this.showSuccess = false;
            this.valid[event.inputIndex] = event.valid;
        },
        finalValidation() {
            if (this.valid.includes(false)) {
                this.showAlert = true;
                window.scrollTo(0, 0);
            } else {
                if (this.userIDLocal !== undefined) this.editUser();
                else this.createUser();
            }
        },
        createUser() {
            this.registerUser(this.user)
                .then((response) => {
                    // console.log("USUARIO creado correctamente");
                    // console.log(response.data.user);
                    window.scrollTo(0, 0);
                    this.showSuccess = true;
                    this.userIDLocal = response.data.user.id;
                    delete response.data.user.id;
                    delete response.data.user.created_at;
                    delete response.data.user.updated_at;
                    this.user = response.data.user;
                    //this.$router.replace({ path: `/user-card/${response.data.user.id}` });
                })
                .catch((err) => console.log("Error al crear USUARIOS", err))
        },
        editUser() {
            // console.log("EDITANDO USUARIO");
            // console.log(this.user)
            this.plain
                .patch(`/users/${this.userIDLocal}`, this.user,
                    {
                        headers: {
                            'Authorization': this.getAuthToken
                        }
                    }
                )
                .then((response) => {
                    // console.log("USUARIO editado correctamente");
                    // console.log(response.data.user);
                    window.scrollTo(0, 0);
                    this.showSuccess = true;
                    //this.userID = response.data.id;
                    delete response.data.user.id;
                    delete response.data.user.created_at;
                    delete response.data.user.updated_at;
                    this.user = response.data.user;
                    // console.log("EDIT");
                    // console.log(this.user);
                })
                .catch((error) => {
                    console.log("Error al editar USUARIOS", error);
                });
        },
        changeRol(rol) {
            this.user.rol = rol
            // console.log(this.user)
        }
    },
};
</script>
  